import apiClient from "./api";

export interface PosRegister {
  id?: number;
  user_id: number;
  opening_balance: number;
  opened_at: string;
  payments_cash: number;
  payments_bank: number;
  subtotal: number;
  total_discount: number;
  expected_balance: number;
  closing_balance: number;
  difference: number;
  closed_at: string | null;
  close_note: string | null;
  status: number;
  user?: {
    id?: number;
    first_name?: string;
    last_name?: string;
    username?: string;
    email?: string;
  };
  creator?: {
    id?: number;
    first_name?: string;
    last_name?: string;
    username?: string;
  };
  closer?: {
    id?: number;
    first_name?: string;
    last_name?: string;
    username?: string;
  };
}

export interface RegisterHistoryResponse {
  current_page: number;
  data: PosRegister[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

const registerService = {
  async checkRegister() {
    const response = await apiClient.get("/pos/check");
    return response.data;
  },
  async getHistory(params?: {
    user_id?: string | number;
    status?: string | number;
    from_date?: string;
    to_date?: string;
    search_query?: string;
    page?: number;
    per_page?: number | string;
  }): Promise<RegisterHistoryResponse> {
    const response = await apiClient.get("/pos/register-history", { params });
    return response.data.data ?? response.data;
  },
  async openRegister(opening_balance: number) {
    const response = await apiClient.post("/pos/open-register", { opening_balance });
    return response.data;
  },
  async closeRegister(closing_balance: number, close_note = "") {
    const response = await apiClient.post("/pos/close-register", { closing_balance, close_note });
    return response.data;
  },
  async updateRegister(id: number, data: Partial<PosRegister>) {
    const response = await apiClient.put(`/pos/update-register/${id}`, data);
    return response.data;
  }
};

export default registerService;
